import { render } from "./PartnersPage.vue?vue&type=template&id=45cb6241&scoped=true"
import script from "./PartnersPage.vue?vue&type=script&lang=js"
export * from "./PartnersPage.vue?vue&type=script&lang=js"

import "./PartnersPage.vue?vue&type=style&index=0&id=45cb6241&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cb6241"]])

export default __exports__